import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs';
import { AnalyticsService } from '../../../../@core/utils/analytics.service';
import { STUDENT_HELP_REQUEST } from '../../../../config/mock-data';
import { ClearObservableHelper } from '../../../../helpers/ClearObservableHelper';
import { Classroom } from '../../../../interface/calendar';
import { PacingPlanService } from '../../../../services/pacing-plan.service';
import { StorageService } from '../../../../services/storage.service';
import { StudentService } from '../../../../services/student.service';
import { UtilService } from '../../../../services/util.service';
declare var bootstrap: any;

@Component({
  selector: 'ngx-teacher-dashboard-help-requests',
  templateUrl: './teacher-dashboard-help-requests.component.html',
  styleUrls: ['./teacher-dashboard-help-requests.component.scss'],
})
export class TeacherDashboardHelpRequestsComponent extends ClearObservableHelper implements OnInit, AfterViewInit {
  @ViewChild('helpRequestModal', { static: false }) modalElement!: ElementRef;
  modalInstance: any;
  @Input() isModal = false;
  @Input() classroom: Classroom;
  studentExtraHelp = [];
  currentPage = 1;
  loading = false;
  totalPages = 1;
  currentRequest;
  public modalRef;
  @ViewChild('myModal') myModal;
  @Output() closeExpandViewModal = new EventEmitter<boolean>();
  mockData = this.storageservice.getItem('user').user['is_trial_user'] ? true : false;

  constructor(
    private extraHelpService: StudentService,
    public modalService: NgbModal,
    private pacingPlanService: PacingPlanService,
    public alayticsService: AnalyticsService,
    private spinner: NgxSpinnerService,
    public router: Router,
    public storageservice: StorageService,
    public dialog: MatDialog,
    public utilService: UtilService,
  ) {
    super();
  }

  async ngOnInit() {
    try {
      // this.loading = true;
      this.spinner.show();

      if (this.mockData) {
        this.studentExtraHelp = STUDENT_HELP_REQUEST;
        this.spinner.hide();
        return;
      }

      if (this.classroom) await this.getStudentExtraHelpByClassroomIdAndCorrectNess();
      this.loading = false;

      this.pacingPlanService.changeClassroom.subscribe(async (x: any) => {
        if (x?.id) {
          this.loading = true;
          this.classroom = x;
          if (this.classroom) await this.getStudentExtraHelpByClassroomIdAndCorrectNess();
          this.loading = false;
        }
      });

      // Subscribe to selected school calendar change so that changes should reflect when user changes the calendar from header
      this.storageservice.setSelectedSchoolsCalendarToLocalStorage.pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
        if (res) {
          await this.getStudentExtraHelpByClassroomIdAndCorrectNess();
        }
      });

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      // this.loading = false;
    }
  }

  ngAfterViewInit(): void {
    try {
      if (this.modalElement) {
        this.modalInstance = new bootstrap.Modal(this.modalElement.nativeElement, {
          backdrop: 'static',
          keyboard: false,
          focus: true,
        });
      }
    } catch (error) {
      console.log('Bootstrap modal init:', error);
    }
  }

  async getStudentExtraHelpByPage() {
    try {
      this.loading = true;
      await this.getStudentExtraHelpByClassroomIdAndCorrectNess();
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  async getStudentExtraHelpByClassroomIdAndCorrectNess() {
    try {
      if (this.classroom) {
        const studentHelpRequests: any = await this.extraHelpService.getStudentExtraHelpByClassroomIdAndCorrectNess({
          classroom_id: this.classroom.id,
          isModal: this.isModal,
          page: this.currentPage,
        });

        this.totalPages = studentHelpRequests.pageTotal;

        this.studentExtraHelp = studentHelpRequests.items;
      }
    } catch (error) {
      // console.log(error);
    }
  }

  closeDialog() {
    this.closeExpandViewModal.emit(true);
  }

  openHelpRequestModal(helpRequest): void {
    try {
      // this.dialog.closeAll();

      this.currentRequest = helpRequest;
      this.modalInstance.show();

      // this.modalRef = this.modalService.open(this.myModal, {
      //   size: 'lg',
      //   modalDialogClass: 'mymodal',
      //   centered: true,
      //   backdrop: 'static',
      //   animation: true,
      //   keyboard: false,
      //   backdropClass: 'modal-backdrop',
      //   windowClass: 'custom-overlay-container',
      // });
    } catch (error) {
      // console.log(error);
    }
  }

  closeModal(): void {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }
}
